const CONTENT_WRP_ID = 'contentWrp';

const scrollTo = (
  element: string | {
    current: {
      offsetTop: number,
    },
  },
  options: {
    offset?: number,
    scrollContainerId?: string,
  },
): void => {
  let targetOffset;
  if (typeof element === 'string') {
    targetOffset = document.getElementById(element).offsetTop;
  } else if (typeof element === 'object') {
    targetOffset = element.current.offsetTop;
  } else {
    throw 'scrollTo function accepts as element only id(string) of this element or ref(object)';
  }
  let addPixels = options.offset || 0;
  let endPoint = targetOffset + addPixels;
  document.getElementById(options.scrollContainerId || CONTENT_WRP_ID).scrollTo({
    top: endPoint,
    behavior: 'smooth',
  });
};

export default scrollTo;
